import { always, curry, isNil, when } from 'ramda';
import { convert } from './convert';

// Similar to `convert` but returns identity (the input value) when a conversion is not found
export const convertOrIdentity = curry((pairs, value) =>
	when(isNil, always(value))(convert(pairs, value))
);
